import queryString from 'querystring';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { employeeChangeLogsStateForEmployeeIdSelector } from '../employee-change-log-selectors';

import * as Api from '../../api/api';

export const loadEmployeeChangeLogs = (employeeId: number) =>
  createGenericDispatcher({
    name: 'LOAD_EMPLOYEE_CHANGE_LOGS',
    loadFunction: () => Api.get(`/employee-change-logs?${queryString.stringify({ employeeId })}`),
    args: { employeeId },
    shouldExecuteSelector: (state: any) =>
      employeeChangeLogsStateForEmployeeIdSelector(state, employeeId),
  });
